/**
 * Public site 404 — unknown marketing URLs (Bugs #1386, #1391).
 * Replaces silent redirects to the homepage so visitors see a clear not-found state.
 */

import { Box, Button, Container, Stack, Text, Title, rem } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { PublicFooter, PublicNav } from '../components/landing';
import { brandColors, commonStyles, semanticColors } from '../config/theme';
import { PUBLIC_ROUTES } from '../constants/routes';
import { usePageMeta } from '../hooks/usePageMeta';
import { PUBLIC_TITLE_BRAND_SUFFIX } from '../content/publicPageMeta';

/**
 * Standalone public 404 with marketing chrome.
 */
export function PublicNotFoundPage() {
  const navigate = useNavigate();
  usePageMeta({
    title: `Page not found${PUBLIC_TITLE_BRAND_SUFFIX}`,
    description: 'That page is not on Scheduled Smiles. Return to the homepage to browse e-cards, mailed cards, and flowers.',
    noindex: true,
  });

  return (
    <Box
      style={commonStyles.warmPageBackground}
      data-testid="public-not-found-page"
    >
      <Box style={{ background: semanticColors.bg.navBar }}>
        <Container size="lg" py={rem(14)}>
          <PublicNav />
        </Container>
      </Box>
      <Container size="sm" py={rem(64)}>
        <Stack align="center" gap="md" ta="center">
          <Title order={1} c={semanticColors.text.title}>
            Page not found
          </Title>
          <Text c={semanticColors.text.body}>
            We couldn&apos;t find that page. Check the URL or head back to the homepage.
          </Text>
          <Button color={brandColors.primary} onClick={() => navigate(PUBLIC_ROUTES.home)}>
            Go to homepage
          </Button>
        </Stack>
      </Container>
      <Container size="lg" py={rem(20)}>
        <PublicFooter />
      </Container>
    </Box>
  );
}
